import { useEffect } from 'react';

import { useTaskFrameStore, useToolPermissionStore } from '@/store';

const Reviewing = () => {
  const { currentFrame, isAssignedReviewMe } = useTaskFrameStore();
  const { setPermission } = useToolPermissionStore();

  const isAssignedMe = isAssignedReviewMe();

  useEffect(() => {
    setPermission({
      labeling: {
        readable: true,
        updatable: isAssignedMe,
        acceptable: false,
      },
      labelingReview: {
        readable: true,
        updatable: isAssignedMe,
        acceptable: isAssignedMe,
      },
      preAnnotation: {
        acceptable: isAssignedMe,
      },
      aiAssist: {
        acceptable: isAssignedMe,
      },
    });
  }, [currentFrame?.frameSeq, currentFrame?.workState]);

  return <></>;
};

export default Reviewing;
